import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class PaginationService {
  // Standardized page size options for all paginations
  readonly PAGE_SIZE_OPTIONS = [10, 25, 50, 100, 250, 500];
  
  // Default page size
  readonly DEFAULT_PAGE_SIZE = 10;
  
  // localStorage key for storing user's preferred page size
  private readonly PAGE_SIZE_STORAGE_KEY = 'smarthcaap_page_size';

  /**
   * Get user's preferred page size from localStorage, or return default
   */
  getPageSize(): number {
    const stored = localStorage.getItem(this.PAGE_SIZE_STORAGE_KEY);
    if (stored) {
      const pageSize = parseInt(stored, 10);
      // Validate that stored value is one of our options
      if (this.PAGE_SIZE_OPTIONS.includes(pageSize)) {
        return pageSize;
      }
    }
    return this.DEFAULT_PAGE_SIZE;
  }

  /**
   * Save user's preferred page size to localStorage
   */
  setPageSize(pageSize: number): void {
    if (this.PAGE_SIZE_OPTIONS.includes(pageSize)) {
      localStorage.setItem(this.PAGE_SIZE_STORAGE_KEY, pageSize.toString());
    }
  }

  /**
   * Get standardized page size options
   */
  getPageSizeOptions(): number[] {
    return [...this.PAGE_SIZE_OPTIONS];
  }
}

